<template>
  <div class="loginPage">
    <div class="logoWrap">
      <div class="logo" v-if="isRisSystem">
        <img src="../../assets/images/loginLogo.png" alt="" srcset="" />
      </div>
      <div class="logoAi" v-if="!isRisSystem">
        <img src="../../assets/images/txLogo.png" alt="" srcset="" />
        <span class="logoTitle">AI订单系统</span>
      </div>
    </div>
    <!-- <Form class="loginContainer" :form="form" @submit="handleSubmit">
      <h2><span>欢迎登录</span>{{isRisSystem ? '医学影像信息系统' : 'AI订单系统' }}</h2>
      <FormItem>
        <Input size="large" type="text" placeholder="请输入手机号" v-decorator="['mobile', {rules: [{ required: true, pattern: /^1\d{10}$/, message: '请输入正确的手机号' }], validateTrigger: 'change'}]">
          <Icon slot="prefix" type="user"/>
        </Input>
      </FormItem>
      <FormItem >
        <Input size="large" type="password" autocomplete="false" placeholder="请输入密码" v-decorator="['password', {rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}]">
          <Icon slot="prefix" type="lock"/>
        </Input>
      </FormItem>
      <Row :gutter="16">
        <Col :span="12">
          <FormItem>
            <Input size="large" type="text" placeholder="验证码" v-decorator="['code', {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}]">
              <Icon slot="prefix" type="safety-certificate" />
            </Input>
          </FormItem>
        </Col>
        <Col :span="8">
          <img :src="imgUrl" alt="点击切换验证码" title="点击切换验证码" class="checkCodeImg" @click="getCheckCodeImg" />
        </Col>
        <Col :span="4">
          <Icon type="reload" style="font-size:40px;" @click="getCheckCodeImg(true)" :class="{rotate: rotateFlag}"/>
        </Col>
      </Row>
      <FormItem class="loginBtnWrap">
        <Button size="large" type="primary" htmlType="submit" :loading="loginBtn" :disabled="loginBtn">登 录</Button>
      </FormItem>
    </Form> -->
    <Form class="loginContainer">
      <h2><span>欢迎登录</span>{{isRisSystem ? '医学影像信息系统' : 'AI订单系统' }}</h2>
      <FormItem>
        <Input size="large" autocomplete="true" name="mobile" type="text" placeholder="请输入手机号" v-model.trim="mobile">
          <Icon slot="prefix" type="user" :style="{ color: 'rgba(0, 0, 0, 0.25)' }"/>
        </Input>
      </FormItem>
      <FormItem>
        <Row :gutter="16" style="width: 100%;">
          <Col :span="16">
            <Input size="large" type="text" placeholder="请输入验证码" v-model.trim="code">
              <Icon slot="prefix" type="lock" :style="{ color: 'rgba(0, 0, 0, 0.25)' }"/>
            </Input>
          </Col>
          <Col :span="8">
            <Button type="primary" style="background-color: #1aaa55; color: #FFFFFF;" :disabled="codeTimer ? true : false" size="large" @click="showSlideVerify">{{ sendCodeBtnText }}</Button>
          </Col>
        </Row>
      </FormItem>
      <FormItem>
        <Button size="large" block type="primary" @click="loginAction" class="login-button" :loading="loginBtnLoading" :disabled="loginBtnLoading">登 录</Button>
      </FormItem>
    </Form>
    <Modal title="安全验证" :visible="slideVerifyVisible" :footer="null" :width="360" class="checkCodeModal" @cancel="slideVerifyVisible = false">
      <div class="slider">
        <div class="content">
          <div class="bg-img-div">
            <img id="bg-img" v-if="codeImgConf.captcha" :src="codeImgConf.captcha.backgroundImage" alt/>
          </div>
          <div class="slider-img-div" id="slider-img-div">
            <img id="slider-img" v-if="codeImgConf.captcha" :src="codeImgConf.captcha.templateImage" alt/>
          </div>
          <div class="slider-refresh-btn" @click="refreshImgCode">
            <Icon type="reload" />
          </div>
        </div>
        <div class="slider-move">
          <div class="slider-move-track">
            <span v-if="sliderStatus == 'ready'">拖动滑块完成拼图</span>
            <div class="slider_indicator" id="slider_indicator"></div>
            <div class="slider-move-btn" id="slider-move-btn" @mousedown="mousedownAction" @touchstart="mousedownAction">
              <Icon type="arrow-right" v-if="sliderStatus == 'move' || sliderStatus == 'ready'"/>
              <Icon type="check" v-if="sliderStatus == 'success'"/>
              <Icon type="close" v-if="sliderStatus == 'error'"/>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { Form, Input, Icon, Button, Row, Col, Modal } from 'ant-design-vue'
import { getCodeImg, accountLogin, getAuthUserInfo, genCodeImage, checkCode } from '../../api/user'
import { setSession, getSession, toast, checkPhone, switchTimeFormat } from '../../libs/utils'
import { sortBy, filter, isArray, find, remove } from 'lodash'
import { getAllHeaderMenuUrl } from '../../config'
export default {
  components: {
    Form,
    FormItem: Form.Item,
    Input,
    Icon,
    Button,
    Row,
    Col,
    Modal,
},
  data () {
    return {
      imgUrl: '',
      loginBtnLoading: false,
      form: this.$form.createForm(this),
      randomStr: '',
      rotateFlag: false,
      rotateTimer: null,
      isRisSystem: true,
      mobile: '',
      code: '',
      slideVerifyVisible: false,
      codeTimer: null,
      sendCodeBtnText: '获取验证码',
      sendTimeNum: 60,
      codeImgConf: {},
      sliderStatus: 'ready',
      currentCaptchaConfig: {}
    }
  },
  created () {
    if (window.location.href.indexOf('webris.tongxinyiliao.com') == -1) this.isRisSystem = false
    let userInfo = getSession('risUserInfo', 'object') || null
    let userAuth = getSession('userAuth', 'object') || null
    if (userInfo && userInfo.id && userAuth && userAuth.authMenus) {
      return this.redirectByRoles(userInfo.roles, userInfo.centerVos, userAuth.authMenus)
    }
    this.getCheckCodeImg()
  },
  methods: {
    getCheckCodeImg(rotate){
      if (rotate) this.rotateFlag = true
      let { randomStr, imgUrl } = getCodeImg()
      this.randomStr = randomStr
      this.imgUrl = `${imgUrl}?v=${randomStr}`
      this.rotateTimer = setTimeout(() => {
        this.rotateFlag = false
        clearTimeout(this.rotateTimer)
        this.rotateTimer = null
      }, 1000)
    },
    redirectByRoles (roles, centerVos,  authMenus) {
      if (!find(roles, {rcode:  'ROLE_RIS'}) && !find(roles, {rcode:  'ROLE_TECHNICIAN'})) {
        return this.$router.replace({path: `/${authMenus[0]['resources']}`})
      }
      if (!isArray(centerVos) || centerVos.length < 1) {
        throw Error('暂无绑定影像中心，请联系管理员')
      }
      return this.$router.replace({name: 'home'})
    },
    async loginAction () {
      if (!this.mobile) return toast({ msg: `请先输入手机号` })
      if (!checkPhone(this.mobile)) return toast({ msg: `请输入正确手机号` })
      if (!this.code) return toast({ msg: `请输入短信验证码` })
      const loginParams = { mobile: this.mobile, code: this.code, syStemType: 'RIS' }
      try {
        this.loginBtnLoading = true
        let data = await accountLogin(loginParams)
        setSession('risUserInfo', data)
        setSession('loginTime', new Date().valueOf())
        let userInfo = await getAuthUserInfo()
        const { roles, menus, centerVos } = userInfo
        if (!isArray(roles) || roles.length < 1) {
          throw Error('暂无使用权限，请联系管理员为您分配角色')
        }
        if (!isArray(menus) || menus.length < 1) {
          throw Error('您没有使用系统的权限，请联系管理员')
        }
        const allHeaderMenuUrl = getAllHeaderMenuUrl()
        const menuArr = filter(menus, function(item) {
          return allHeaderMenuUrl.includes(item.resources)
        })
        if (!find(roles, {rcode: 'ROLE_RIS'})) {
          remove(menuArr, function (item) {
            return item.resources === 'ris/queue'
          })
        }
        if (!find(roles, {rcode: 'ROLE_TECHNICIAN'})) {
          remove(menuArr, function (item) {
            return item.resources === 'ris/callNum'
          })
        }
        if (!find(roles, {rcode: 'ROLE_CHECK_SCREENING'})) {
          remove(menuArr, function (item) {
            return item.resources === 'ris/screening'
          })
        }
        const authMenus = sortBy(menuArr, 'pid')
        if (authMenus.length < 1) {
          throw Error('您没有使用系统的权限，请联系管理员')
        }
        setSession('userAuth', { centerVos: centerVos, roles: roles, authMenus: authMenus })
        this.redirectByRoles(roles, centerVos, authMenus)
      } catch (error) {
        toast({ title: '错误提示', msg: error.message || '登陆异常'})
      } finally {
        this.loginBtnLoading = false
      }
    },
    // 图片验证码验证
    async showSlideVerify () {
      if (this.codeTimer) return false
      if (!this.mobile) return toast({ msg: `请先输入手机号` })
      if (!checkPhone(this.mobile)) return toast({ msg: `请输入正确手机号` })
      this.slideVerifyVisible = true
      await this.refreshImgCode()
    },
    initCurCaptchaConfig () {
      this.currentCaptchaConfig = {
        startTime: new Date(),
        stopTime: '',
        startX: 0,
        startY: 0,
        trackArr: [],
        end: 300,
        moveX: 0
      }
      this.sliderStatus = 'ready'
    },
    async refreshImgCode () {
      const conf = await genCodeImage()
      if (conf) this.codeImgConf = conf
      this.initCurCaptchaConfig()
      this.sliderShowMoveResult(0)
    },
    mousemoveHandle (event) {
      this.sliderStatus = 'move'
      if (event instanceof TouchEvent) {
        event = event.touches[0]
      }
      const pageX = Math.round(event.pageX)
      const pageY = Math.round(event.pageY)
      const startX = this.currentCaptchaConfig.startX
      const startY = this.currentCaptchaConfig.startY
      const startTime = this.currentCaptchaConfig.startTime
      const end = this.currentCaptchaConfig.end
      const trackArr = this.currentCaptchaConfig.trackArr
      let moveX = pageX - startX
      const track = { x: pageX - startX, y: pageY - startY, type: 'move', t: (new Date().getTime() - startTime.getTime()) }
      trackArr.push(track)
      if (moveX < 0) moveX = 0
      else if (moveX > end) moveX = end
      this.currentCaptchaConfig.moveX = moveX
      this.sliderShowMoveResult(moveX)
    },
    sliderShowMoveResult (moveX) {
      if (this.sliderStatus === 'move' || this.sliderStatus === 'ready') {
        document.querySelector('#slider-move-btn').style = `transform: translate(${moveX}px, 0);`
        document.querySelector('#slider-img-div').style = `transform: translate(${moveX}px, 0);`
        document.querySelector('#slider_indicator').style = `width: ${moveX}px;`
      } else if (this.sliderStatus === 'error') {
        document.querySelector('#slider-move-btn').style = `background-color:#f57a7a; border-color:#f57a7a; color:#ffffff;transform: translate(${this.currentCaptchaConfig.moveX}px, 0);`
        document.querySelector('#slider_indicator').style = `width: ${this.currentCaptchaConfig.moveX}px; background-color:rgba(245,122,122,0.5); border-color:#f57a7a;`
      } else if (this.sliderStatus === 'success') {
        document.querySelector('#slider-move-btn').style = `background-color:#52ccba;color:#ffffff;transform: translate(${this.currentCaptchaConfig.moveX}px, 0)`
        document.querySelector('#slider_indicator').style = `width: ${this.currentCaptchaConfig.moveX}px;border-color: #52ccba;background-color:#d2f4ef;`
      }
    },
    async mouseupHandle () {
      window.removeEventListener('mousemove', this.mousemoveHandle)
      window.removeEventListener('touchmove', this.mousemoveHandle)
      window.removeEventListener('mouseup', this.mouseupHandle)
      window.removeEventListener('touchend', this.mouseupHandle)
      this.currentCaptchaConfig.stopTime = new Date()
      const flag = await this.checkImageCodeAction()
      if (flag) {
        this.sliderStatus = 'success'
        setTimeout(async () => {
          this.slideVerifyVisible = false
          this.codeTimer = setInterval(() => {
          if (this.sendTimeNum <= 1) {
            this.sendCodeBtnText = '获取验证码'
            clearInterval(this.codeTimer)
            this.sendTimeNum = 59
            this.codeTimer = null
          } else {
            this.sendCodeBtnText = `${--this.sendTimeNum}秒后获取`
          }
        }, 1000)
        }, 500)
      } else {
        this.sliderStatus = 'error'
        setTimeout(async () => {
          await this.refreshImgCode()
        }, 500)
      }
      this.sliderShowMoveResult()
    },
    mousedownAction (event) {
      if (event instanceof TouchEvent) {
        event = event.touches[0]
      }
      const startX = event.pageX
      const startY = event.pageY
      this.currentCaptchaConfig.startX = startX
      this.currentCaptchaConfig.startY = startY
      this.currentCaptchaConfig.trackArr.push({ x: 0, y: 0, type: 'down', t: (new Date().getTime() - this.currentCaptchaConfig.startTime.getTime()) })
      window.addEventListener('mousemove', this.mousemoveHandle)
      window.addEventListener('touchmove', this.mousemoveHandle)
      window.addEventListener('mouseup', this.mouseupHandle)
      window.addEventListener('touchend', this.mouseupHandle)
    },
    async checkImageCodeAction () {
      try {
        const params = {
          id: this.codeImgConf.id,
          bgImageWidth: this.codeImgConf.captcha.backgroundImageWidth,
          bgImageHeight: this.codeImgConf.captcha.backgroundImageHeight,
          startSlidingTime: switchTimeFormat(this.currentCaptchaConfig.startTime, 3),
          entSlidingTime: switchTimeFormat(this.currentCaptchaConfig.stopTime, 3),
          trackList: this.currentCaptchaConfig.trackArr,
          mobile: this.mobile
        }
        const checkData = await checkCode(params)
        return checkData
      } catch (error) {
        toast({ msg: error.message || '校验验证码异常' })
      }
    }
  }
}
</script>
<style lang="less">
.loginPage{
  position: relative;
  height: 100%;
  background: url('../../assets/images/loginBg.jpg') no-repeat center center;
  background-size: cover;
  .logoWrap{
    padding: 30px;
    .logo img{
      width: 278px;
      height: auto;
    }
    .logoAi {
      display: flex;
      align-items: center;
      img{
        height: 60px;
      }
      .logoTitle{
        color: #fff;
        font-size: 26px;
        font-weight: bolder;
      }
    }
  }
  @media all and (min-width: 576px) {
    .loginContainer{
      background-color: #fff;
      min-width: 260px;
      width: 380px;
      padding: 0 24px;
      border-radius: 8px;
      position: absolute;
      left: 70%;
      top:50%;
      transform: translate(-50%, -50%);
      h2{
        padding: 20px 0;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
      }
    }
  }
  @media all and (max-width: 576px) {
    .loginContainer{
      background-color: #fff;
      padding: 20px 10px;
      min-width: 260px;
      border-radius: 8px;
      margin: 0 12px;
      .checkCodeImg{
        width: 100px;
        height: 40px;
      }
      h2{
        padding: 0 0 10px 0;
        text-align: center;
        font-size: 20px;
      }
      .checkCodeImg{
        border:none;
        cursor: pointer;
        transition: transform 1s;
        transform-origin:center center;
        transform: rotate(0);
      }
      .loginBtnWrap{
        margin-bottom: 0;
        button{
          width: 100%;
        }
      }
      .rotate{
        transition: transform 1s;
        transform-origin:center center;
        transform: rotate(360deg);
      }
    }
  }
}
.checkCodeModal{
  .ant-modal{
    min-width: 360px;
  }
  .ant-modal-body{
    padding: 10px;
  }
  .slider {
    .content {
      width: 100%;
      height: 170px;
      position: relative;
      .slider-refresh-btn{
        position: absolute;
        right: 20px;
        top: 10px;
        z-index: 999;
        color: #FFFFFF;
        font-size: 20px;
        cursor: pointer;
      }
    }
    .bg-img-div {
      width: 100%;
      height: 100%;
      position: absolute;
      transform: translate(0px, 0px);
    }
    .slider-img-div {
      height: 100%;
      position: absolute;
      transform: translate(0px, 0px);
    }
    .bg-img-div img {
      width: 100%;
    }
    .slider-img-div img {
      height: 100%;
    }
    .slider-move {
      width: 100%;
      margin: 10px 0 0 0;
      position: relative;
    }
    .slider-move-track {
      width: 100%;
      line-height: 38px;
      font-size: 14px;
      height: 40px;
      text-align: center;
      white-space: nowrap;
      color: #45494c;
      border-radius: 2px;
      border: 1px solid #e4e7eb;
      background-color: #f7f9fa;
      -moz-user-select: none;
      -webkit-user-select: none;
      user-select: none;
      position: relative;
      .slider_indicator{
        width: 0;
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        background-color: #d1e9fe;
        border: 1px solid #1991fa;
      }
      .slider-move-btn{
        position: absolute;
        background-color: #1991fa;
        width: 40px;
        height: 100%;
        transform: translate(0px, 0px);
        top: 0;
        left: 0;
        color: #FFFFFF;
        &:hover{
          cursor: pointer
        }
      }
    }
  }
}
</style>